export const SET_PWA_APPBAR_BACKLINK = 'SET_PWA_APPBAR_BACKLINK';
